import { Component, Vue, Prop, Ref, Watch } from 'vue-property-decorator';
import { Camera } from '@/models/camera';
import { Project } from '@/models/project';
import { Photo } from '@/models/photo';
import { Album } from '@/models/album';
import { Getter, State, Action } from 'vuex-class';
import { Storage } from 'aws-amplify';
import VueSlider from 'vue-slider-component';
import axios from 'axios';
// @ts-ignore no d.ts
import Datepicker from 'vuejs-datepicker';
// @ts-ignore no d.ts
import { en, fr } from 'vuejs-datepicker/dist/locale';
import { Validations } from 'vuelidate-property-decorators';
import { minLength, required } from 'vuelidate/lib/validators';
import { AlbumCreateRequest } from '@/services/albums/albums.interfaces';
import EditShareModal from '../editsharemodal/editsharemodal.component.vue';
import ImportPhotosModal from '../importphotos/importphotos.component.vue';
import S3Image from '../s3-image/S3Image.vue';
import BlurModal from '@/components/blurmodal/blurmodal.component.vue';
import { BTooltip } from 'bootstrap-vue';
import { Logger } from 'aws-amplify';
import { format } from 'date-fns';
import { User } from '@/models/user';
import { cameraService } from '@/services';
import jsPDF from 'jspdf';
// @ts-ignore si TS fait la tête
import autoTable from 'jspdf-autotable';
import html2canvas from 'html2canvas';
const logger = new Logger('Gallery');

interface S3GetResponse {
  Body: Blob | ArrayBuffer;
  // Include other properties if necessary
}

interface GanttTask {
  id: string;
  name: string;
  color: string;
  left: number;
  width: number;
  startDate: Date;
  endDate: Date;
  lane?: string;
  type?: 'project' | 'lane' | 'phase';
  isCollapsed?: boolean;
}

interface GanttTick {
  left: number; // position en %
  label: string; // texte affiché
  isEdge: boolean; // début / fin de frise
}

@Component({
  components: {
    VueSlider,
    Datepicker,
    EditShareModal,
    ImportPhotosModal,
    S3Image,
    BlurModal,
    BTooltip,
  },
})
export default class Gallery extends Vue {
  public currentImageKey: Photo | null = null;
  public sliderValue: Photo | null = null;
  public sliderIsDragging = false;
  public isSliderFirstItem = false;
  public isSliderLastItem = true;
  public switchBeforeAfter = false;
  public createdAlbum = '';
  public selectedAlbum = '';
  private photoFavAlbum = true;
  private pickedDate: Date | null = null;
  public isTakingPicture = false;
  public isDesactivate = false;
  public isMirroring = false;
  public mirroringSuccess = false;
  private _cancelPinch?: (e: TouchEvent) => void;
  private _cancelDoubleTap?: (e: TouchEvent) => void;
  private _lastTouchTs = 0;

  private touchStartX = 0;
  private touchStartY = 0;
  private touchEndX = 0;
  private touchEndY = 0;
  private touchStartTime = 0;
  private isSwiping = false;
  private minSwipeDistance = 50; // Distance minimale pour déclencher un swipe
  private maxVerticalDistance = 100;
  private minSwipeTime = 50;

  private listenersAdded = false;

  public collapsedLanes: string[] = [];

  @Validations()
  private validations = {
    selectedAlbum: { required },
    createdAlbum: { required, minLength: minLength(3) },
  };

  @Prop({ required: true, type: Object }) private readonly camera!: Camera;
  @Prop({ required: true, type: Object }) private readonly project!: Project;
  @Prop({ required: true, type: Boolean }) private readonly newPhotoAvailable!: boolean;
  @Prop({ required: true }) readonly isPremium!: boolean;
  @Prop({ required: true }) readonly isGuest!: boolean;
  @Prop({ type: Array, default: () => [] }) readonly selectedPhotos!: Photo[];
  @Prop({ type: Boolean, default: false }) readonly useIA!: boolean;
  @Prop({ type: Boolean, default: false }) readonly useSecurityMode!: boolean;
  @Prop({ type: Boolean, default: false })
  readonly hideFavorite!: boolean;
  @Prop({ type: Boolean, default: false }) readonly hideGoutte!: boolean;
  @Prop({ type: Boolean, default: false }) readonly hideUpload!: boolean;
  @Prop({ type: Boolean, default: false }) readonly hideCompareBtn!: boolean;
  @Prop({ type: Boolean, default: false }) readonly hideFullscreen!: boolean;
  @Prop({ type: Boolean, default: false })
  readonly preferMediumInFullScreen!: boolean;

  @Prop({ type: Array, default: () => [] })
  readonly phases!: {
    id: string;
    name: string;
    date: string | Date;
    color?: string;
    start?: string | Date;
    end?: string | Date;
    lane?: string;
  }[];

  private localPhases: {
    id: string;
    name: string;
    date: string | Date;
    color?: string;
    start?: string | Date;
    end?: string | Date;
    lane?: string;
  }[] = [];

  @Ref('slider') private readonly slider!: VueSlider;

  @State('locale', { namespace: 'profile' }) private locale!: string;
  @State('user', { namespace: 'profile' }) private user!: User;
  @State('isLoading', { namespace: 'photo' }) private readonly isLoadingPhoto!: boolean;
  @State('photos', { namespace: 'photo' }) private readonly photosStore?: Photo[];
  @State('photosByCameraId', { namespace: 'photo' }) private readonly photosByCameraId!: {
    [cameraId: string]: Photo[];
  };
  @Getter('onlyPhoto', { namespace: 'photo' }) private onlyPhoto!: Photo[];

  @State('albums', { namespace: 'album' }) private readonly albums!: Album[];
  @Action('createNewAlbum', { namespace: 'album' }) private readonly createNewAlbum!: (
    cameraCreateRequest: AlbumCreateRequest
  ) => Promise<Album[]>;
  @Action('addPhoto', { namespace: 'album' }) private readonly addPhoto!: (payload: {
    albumId: string;
    photoId: string;
  }) => Promise<void>;

  public zoomLevel = 1;
  private minSwipeZoomThreshold = 1.02;

  public phaseModalColor = '#5fc9e4';

  public phaseModalStart: Date | null = null;
  public phaseModalEnd: Date | null = null;
  public phaseModalLane = '';
  public phaseModalLaneSelect: string | null = null;

  public phaseLinkStartId: string | null = null;
  public phaseStartLinkKey: string | null = null;
  public phaseEndLinkKey: string | null = null;
  public phaseLinkEndId: string | null = null;

  public phaseModalMode: 'create' | 'edit' = 'create';
  public phaseModalLabel = '';
  public phaseModalPhoto: Photo | null = null;
  public phaseModalPhaseId: string | null = null;
  public selectedPhaseTaskId: string | null = null;

  private phaseMarksByPhotoId: Record<string, { label: string; phaseId?: string; color?: string }> = {};

  get canSwipe(): boolean {
    // pas de swipe en mode theater (plein écran) ni quand zoom > seuil
    return !this.zoom && this.zoomLevel <= this.minSwipeZoomThreshold;
  }

  get filteredPhotos(): Photo[] {
    return this.photosStore?.filter((photo) => photo.cameraId === this.camera.id) || [];
  }

  public get phaseDateLinkOptions() {
    if (!this.localPhases || !this.localPhases.length) {
      return [{ value: null, text: 'Définir manuellement' }];
    }

    const options: { value: string | null; text: string }[] = [{ value: null, text: 'Définir manuellement' }];

    for (const p of this.localPhases as any[]) {
      const name = p.name || '(Sans nom)';

      const startRaw = p.start || p.date;
      const endRaw = p.end || p.start || p.date;

      const startLabel = this.formatDateForExport(startRaw);
      const endLabel = this.formatDateForExport(endRaw);

      // Début de ce jalon
      options.push({
        value: `${p.id}|start`,
        text: `Début de "${name}" (${startLabel})`,
      });

      // Fin de ce jalon
      options.push({
        value: `${p.id}|end`,
        text: `Fin de "${name}" (${endLabel})`,
      });
    }

    return options;
  }

  public get phaseLaneSuggestions(): string[] {
    const lanes: string[] = [];
    const seen = new Set<string>();

    // On se base sur la copie locale des phases (celle que tu utilises déjà pour le Gantt)
    for (const phase of this.localPhases as any[]) {
      const lane = (phase as any).lane as string | undefined;
      if (lane && lane.trim() && !seen.has(lane.trim())) {
        seen.add(lane.trim());
        lanes.push(lane.trim());
      }
    }

    // Optionnel : tri alpha pour que ce soit plus agréable
    return lanes.sort((a, b) => a.localeCompare(b, 'fr', { sensitivity: 'base' }));
  }

  public get laneSelectOptions() {
    const base = this.phaseLaneSuggestions.map((lane) => ({
      value: lane,
      text: lane,
    }));

    return [{ value: null, text: 'Choisir un lot existant' }, ...base, { value: '__custom__', text: 'Nouveau lot...' }];
  }

  public get ganttTicks(): GanttTick[] {
    const { start, end } = this.getGanttRange();
    const total = Math.max(end - start, 1);
    const spanDays = (end - start) / (1000 * 60 * 60 * 24);

    if (!isFinite(spanDays) || spanDays <= 0) {
      return [];
    }

    // 1) Choix du "pas" en fonction de la durée totale
    let stepDays: number;

    if (spanDays <= 15) {
      // vue courte → 1 jour
      stepDays = 1;
    } else if (spanDays <= 60) {
      // ~2 mois → 1 tick / semaine
      stepDays = 7;
    } else if (spanDays <= 180) {
      // 2 à 6 mois → 1 tick tous les 15 jours
      stepDays = 15;
    } else if (spanDays <= 365) {
      // jusqu'à 1 an → 1 tick / mois
      stepDays = 30;
    } else if (spanDays <= 3 * 365) {
      // 1 à 3 ans → 1 tick / trimestre
      stepDays = 90;
    } else {
      // + de 3 ans → 1 tick / an
      stepDays = 365;
    }

    const stepMs = stepDays * 24 * 60 * 60 * 1000;
    const ticks: GanttTick[] = [];

    const addTick = (left: number, label: string, isEdge: boolean) => {
      const minGap = 6; // % minimum entre 2 labels

      const last = ticks[ticks.length - 1];
      if (last) {
        // 1) même label → on ne rajoute pas
        if (label === last.label) return;
        // 2) trop proches → on ne rajoute pas (sauf les bords)
        if (!isEdge && Math.abs(left - last.left) < minGap) return;
      }

      ticks.push({ left, label, isEdge });
    };

    // Tick de début
    addTick(0, this.formatTickLabel(new Date(start), spanDays), true);

    // Ticks intermédiaires
    for (let t = start + stepMs; t <= end - stepMs / 2; t += stepMs) {
      const ratio = (t - start) / total;
      const left = ratio * 100;

      const label = this.formatTickLabel(new Date(t), spanDays);
      addTick(left, label, false);
    }

    // Tick de fin
    addTick(100, this.formatTickLabel(new Date(end), spanDays), true);

    return ticks;
  }

  public onToggleLane(laneName?: string): void {
    if (!laneName) return;
    const idx = this.collapsedLanes.indexOf(laneName);
    if (idx === -1) {
      this.collapsedLanes = [...this.collapsedLanes, laneName];
    } else {
      this.collapsedLanes = this.collapsedLanes.filter((l) => l !== laneName);
    }
  }

  private selectPhaseFromTask(task: GanttTask): void {
    if (task.type !== 'phase') return;

    this.selectedPhaseTaskId = task.id;

    const phase = (this.localPhases as any[]).find((p) => p.id === task.id);
    if (!phase) {
      return;
    }

    this.phaseModalMode = 'edit';
    this.phaseModalPhaseId = phase.id;
    this.phaseModalLabel = phase.name || '';
    this.phaseModalColor = phase.color || '#5fc9e4';
    this.phaseModalLane = (phase as any).lane || '';

    this.phaseLinkStartId = null;
    this.phaseLinkEndId = null;
    this.phaseStartLinkKey = null;
    this.phaseEndLinkKey = null;

    if (this.phaseModalLane && this.phaseLaneSuggestions.includes(this.phaseModalLane)) {
      this.phaseModalLaneSelect = this.phaseModalLane;
    } else if (this.phaseModalLane) {
      this.phaseModalLaneSelect = '__custom__';
    } else {
      this.phaseModalLaneSelect = null;
    }

    const startDate = phase.start ? new Date(phase.start as any) : new Date(phase.date as any);
    const endDate = phase.end ? new Date(phase.end as any) : startDate;

    this.phaseModalStart = startDate;
    this.phaseModalEnd = endDate;

    // 👉 même logique d’ancrage que pour les marks
    const anchorRaw = (phase as any).start || phase.date;
    const anchorDate = new Date(anchorRaw as any);
    const closestPhoto = this.findClosestPhotoToDate(anchorDate);
    this.phaseModalPhoto = closestPhoto || null;

    if (closestPhoto) {
      this.currentImageKey = closestPhoto;
      this.sliderValue = closestPhoto;

      const index = this.imagesKey.findIndex((p) => p.id === closestPhoto.id);
      if (index !== -1 && this.slider) {
        this.slider.setIndex(index);
      }
    }
  }

  private formatTickLabel(date: Date, spanDays: number): string {
    const localeCode = this.locale === 'en' ? 'en-GB' : 'fr-FR';

    // Vue très courte → jour / mois
    if (spanDays <= 31) {
      return date.toLocaleDateString(localeCode, {
        day: '2-digit',
        month: '2-digit',
      });
    }

    // Jusqu'à 6 mois → "15 nov"
    if (spanDays <= 180) {
      return date.toLocaleDateString(localeCode, {
        day: '2-digit',
        month: 'short',
      });
    }

    // Jusqu'à 2 ans → "nov. 24"
    if (spanDays <= 365 * 2) {
      return date.toLocaleDateString(localeCode, {
        month: 'short',
        year: '2-digit',
      });
    }

    // Plus long → juste l'année
    return date.getFullYear().toString();
  }

  public formatPhaseDuration(task: GanttTask): string {
    const diffMs = task.endDate.getTime() - task.startDate.getTime();
    const oneDay = 1000 * 60 * 60 * 24;

    // On garde au moins 1 jour pour éviter les 0 j
    const days = Math.max(1, Math.round(diffMs / oneDay));

    return `${days} j`;
  }

  public get imagesKey(): Photo[] {
    const photos = this.photosByCameraId[this.camera.id] || [];
    // Trier les photos
    const sortedPhotos = photos.slice().sort((photo1, photo2) => {
      return new Date(photo1.createdAt).getTime() - new Date(photo2.createdAt).getTime();
    });

    // Appliquer le filtre jetlag si nécessaire
    if (this.isGuest && this.project.jetlag) {
      return this.filterImagesWithinLagDuration(sortedPhotos, this.project.lagduration);
    } else {
      return sortedPhotos;
    }
  }

  get computedImagePath(): string {
    let basePath = '';

    if (this.camera.blur && !this.zoom) {
      // Sur la page IA et pas en mode plein écran, on utilise toujours la même image (par exemple, mediumKey)
      basePath = this.currentImageKey ? this.currentImageKey.mediumKey : '';
    } else {
      // Pour les autres cas, on adapte en fonction du zoomLevel
      if (this.zoomLevel > 1.8) {
        basePath = this.currentImageKey ? this.currentImageKey.key : '';
      } else {
        basePath = this.currentImageKey ? this.currentImageKey.mediumKey : '';
      }
    }

    if (this.useIA && !this.zoom) {
      // Sur la page IA et pas en mode plein écran, on utilise toujours la même image (par exemple, mediumKey)
      basePath = this.currentImageKey ? this.currentImageKey.mediumKey : '';
    } else {
      // Pour les autres cas, on adapte en fonction du zoomLevel
      if (this.zoomLevel > 1.8) {
        basePath = this.currentImageKey ? this.currentImageKey.key : '';
      } else {
        basePath = this.currentImageKey ? this.currentImageKey.mediumKey : '';
      }
    }

    // Vérifie si useIA est activé et modifie le chemin si nécessaire
    // Vérifie si useIA ou useSecurityMode est activé
    if ((this.useIA || this.useSecurityMode) && basePath) {
      const segments = basePath.split('/');

      let jpgIndex = -1;
      for (let i = segments.length - 1; i >= 0; i--) {
        if (segments[i].toLowerCase().includes('.jpg')) {
          jpgIndex = i;
          break;
        }
      }

      if (jpgIndex !== -1) {
        // Insérer 'IA' et éventuellement 'Segmentation'
        segments.splice(jpgIndex, 0, 'IA');
        if (this.useSecurityMode) {
          segments.splice(jpgIndex + 1, 0, 'Segmentation');
        }
        basePath = segments.join('/');
      } else {
        basePath += '/IA';
        if (this.useSecurityMode) {
          basePath += '/Segmentation';
        }
      }
    }

    return basePath;
  }

  public switchPhaseModalToCreate(): void {
    // On part de la photo actuellement associée au jalon, ou à défaut la photo courante
    const basePhoto = this.phaseModalPhoto || this.currentImageKey;
    if (!basePhoto) return;

    const photoDate = new Date(basePhoto.createdAt);

    // Label par défaut
    const defaultName =
      this.$options.filters && (this.$options.filters as any).dateFormat
        ? `Phase du ${(this.$options.filters as any).dateFormat(photoDate, this.dateFormat)}`
        : `Phase du ${photoDate.toLocaleDateString()}`;

    // On conserve la couleur et le lot du jalon en cours (workflow plus rapide)
    const keepColor = this.phaseModalColor || '#5fc9e4';
    const keepLane = (this.phaseModalLane || '').trim();

    this.phaseModalMode = 'create';
    this.phaseModalPhaseId = null;
    this.selectedPhaseTaskId = null; // enlève la sélection dans le Gantt

    this.phaseModalPhoto = basePhoto;
    this.phaseModalLabel = defaultName;

    this.phaseModalColor = keepColor;
    this.phaseModalLane = keepLane;

    this.phaseLinkStartId = null;
    this.phaseLinkEndId = null;
    this.phaseStartLinkKey = null;
    this.phaseEndLinkKey = null;

    if (keepLane && this.phaseLaneSuggestions.includes(keepLane)) {
      this.phaseModalLaneSelect = keepLane;
    } else if (keepLane) {
      this.phaseModalLaneSelect = '__custom__';
    } else {
      this.phaseModalLaneSelect = null;
    }

    // dates : on repart sur la date de la photo
    this.phaseModalStart = photoDate;
    this.phaseModalEnd = photoDate;
  }

  public get zoom(): boolean {
    return this.$route.query.theater !== undefined;
  }

  public set zoom(set: boolean) {
    if (set && this.$route.query.theater === undefined) {
      this.$router.push({ path: this.$route.path, query: { ...this.$route.query, theater: '' } });
    } else if (this.$route.query.theater === '') {
      this.$router.push({ path: this.$route.path, query: { ...this.$route.query, theater: undefined } });
    }
  }

  public get dateFormat(): string {
    return this.locale === 'en' ? 'MM / DD / YYYY' : 'DD / MM / YYYY';
  }

  public get disabledDates(): unknown {
    const startDate = this.imagesKey[0] ? this.imagesKey[0].createdAt : null;
    const endDate = this.imagesKey[this.imagesKey.length - 1]
      ? this.imagesKey[this.imagesKey.length - 1].createdAt
      : null;
    if (startDate && endDate) {
      const to = new Date(startDate);
      to.setHours(to.getHours() + to.getTimezoneOffset() / 60);
      to.setHours(0);
      const from = new Date(endDate);
      from.setHours(to.getHours() + from.getTimezoneOffset() / 60);
      from.setDate(from.getDate() + 1);
      return {
        ranges: [
          {
            from: new Date(-8640000000000000), // Min date
            to,
          },
          {
            from,
            to: new Date(8640000000000000), // Max date
          },
        ],
      };
    } else {
      return {};
    }
  }

  public get datepickerFormat(): string {
    return this.locale === 'en' ? 'yyyy-dd-MM' : 'dd-MM-yyyy';
  }

  public get datepickerLocal(): unknown {
    return this.locale === 'en' ? en : fr;
  }

  public get isAdmin(): boolean {
    return (
      this.user !== undefined &&
      (this.project.owner.id === this.user.id || this.project.administratorId.includes(this.user.id))
    );
  }

  private get computedFullScreenImagePath(): string {
    // Détermine le chemin de base en fonction du niveau de zoom
    let basePath = '';
    if (!this.useIA && this.zoom) {
      basePath = this.currentImageKey ? this.currentImageKey.key : '';
    } else if (this.zoomLevel > 1.8) {
      basePath = this.currentImageKey ? this.currentImageKey.mediumKey : '';
    } else {
      basePath = this.currentImageKey ? this.currentImageKey.mediumKey : '';
    }

    // Appliquez la logique 'useIA' si nécessaire
    if ((this.useIA || this.useSecurityMode) && basePath) {
      const segments = basePath.split('/');

      let jpgIndex = -1;
      for (let i = segments.length - 1; i >= 0; i--) {
        if (segments[i].toLowerCase().includes('.jpg')) {
          jpgIndex = i;
          break;
        }
      }

      if (jpgIndex !== -1) {
        segments.splice(jpgIndex, 0, 'IA');
        if (this.useSecurityMode) {
          segments.splice(jpgIndex + 1, 0, 'Segmentation');
        }
        basePath = segments.join('/');
      } else {
        basePath += '/IA';
        if (this.useSecurityMode) {
          basePath += '/Segmentation';
        }
      }
    }

    return basePath;
  }

  public get isIaPage(): boolean {
    return this.$route.name === 'ia'; // Remplacez 'IA' par le nom réel de votre route IA
  }

  @Watch('isLoadingPhoto')
  public onLoadingPhotoChanged(newValue: boolean): void {
    if (!newValue) {
      this.$nextTick(() => {
        const zoomerElement = this.$el.querySelector('.gallery-photo-preview-container') as HTMLElement;
        if (zoomerElement) {
          zoomerElement.addEventListener('wheel', this.onWheelZoom);
        } else {
          console.log('zoomerElement not found using querySelector');
        }
      });
    }
  }

  @Watch('currentImageKey')
  public onCurrentImageKeyChange(newVal: Photo | null, oldVal: Photo | null): void {
    if (newVal !== null) {
      this.$emit('selectedPhoto', newVal);
      if (!this.listenersAdded) {
        this.$nextTick(this.addTouchListeners);
      }
    }
  }

  updated(): void {
    if (!this.listenersAdded && this.$refs.swipeZone) {
      this.addTouchListeners();
    }
  }

  private addTouchListeners(): void {
    const swipeZone = this.$refs.swipeZone as HTMLElement | undefined;
    if (!swipeZone || this.listenersAdded) {
      return;
    }

    swipeZone.addEventListener('touchstart', this.onTouchStart, { passive: false, capture: true });
    swipeZone.addEventListener('touchmove', this.onTouchMove, { passive: false, capture: true });
    swipeZone.addEventListener('touchend', this.onTouchEnd, { passive: false, capture: true });

    this.listenersAdded = true;
  }

  public onWheelZoom(event: WheelEvent): void {
    let zoomStep = 0.2; // Incrément de zoom pour la molette de la souris
    const isTrackpad = Math.abs(event.deltaY) < 15 && event.deltaMode === 0; // Détecte les petits incréments typiques du pavé tactile

    if (isTrackpad) {
      zoomStep = 0.002; // Réduire l'incrément de zoom pour le pavé tactile
    }
    if (event.deltaY < 0) {
      this.zoomLevel += zoomStep;
    } else {
      this.zoomLevel -= zoomStep;
    }
    if (this.zoomLevel < 1) {
      this.zoomLevel = 1;
    }
  }

  get sliderMarks(): (value: Photo) => any {
    return (value: Photo) => {
      if (!value) return false;
      const mark = this.phaseMarksByPhotoId[value.id];
      if (!mark) return false;
      return {
        label: mark.label,
      };
    };
  }

  private formatDateForExport(raw: string | Date | undefined): string {
    if (!raw) return '-';
    const d = new Date(raw);

    if (this.$options.filters && (this.$options.filters as any).dateFormat) {
      return (this.$options.filters as any).dateFormat(d, this.dateFormat);
    }

    const localeCode = this.locale === 'en' ? 'en-GB' : 'fr-FR';
    return d.toLocaleDateString(localeCode);
  }

  private computeDurationDays(startRaw: string | Date | undefined, endRaw: string | Date | undefined): number {
    if (!startRaw && !endRaw) return 1;
    const start = startRaw ? new Date(startRaw) : endRaw ? new Date(endRaw) : new Date();
    const end = endRaw ? new Date(endRaw) : start;

    const diffMs = end.getTime() - start.getTime();
    const oneDay = 1000 * 60 * 60 * 24;

    return Math.max(1, Math.round(diffMs / oneDay));
  }

  private buildPhasesGroupedByLane(): {
    lane: string;
    phases: {
      id: string;
      name: string;
      color?: string;
      date: string | Date;
      start?: string | Date;
      end?: string | Date;
      lane?: string;
    }[];
  }[] {
    const groups: { [lane: string]: any[] } = {};
    const defaultLaneLabel = 'Sans lot';

    for (const p of this.localPhases as any[]) {
      const laneName = p.lane && String(p.lane).trim().length > 0 ? String(p.lane).trim() : defaultLaneLabel;

      if (!groups[laneName]) {
        groups[laneName] = [];
      }
      groups[laneName].push(p);
    }

    return Object.keys(groups)
      .sort((a, b) => a.localeCompare(b, 'fr', { sensitivity: 'base' }))
      .map((lane) => ({
        lane,
        phases: groups[lane].sort((a, b) => {
          const aStart = new Date(a.start || a.date).getTime();
          const bStart = new Date(b.start || b.date).getTime();
          return aStart - bStart;
        }),
      }));
  }

  public async exportPhasesToPdf(): Promise<void> {
    if (!this.localPhases || this.localPhases.length === 0) {
      this.$bvToast.toast('Aucun jalon à exporter.', {
        title: this.$t('global.info')?.toString() || 'Info',
        variant: 'info',
        solid: true,
      });
      return;
    }

    const pdf = new jsPDF('landscape', 'mm', 'a4');
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const margin = 10;

    const projectName = (this.project && this.project.name) || 'Projet';
    const cameraName = (this.camera && this.camera.name) || '-';

    const exportDate = new Date();
    const exportLabel = exportDate.toLocaleString(this.locale === 'en' ? 'en-GB' : 'fr-FR');

    const { start, end } = this.getGanttRange();
    const periodLabel = `${this.formatDateForExport(new Date(start))} → ${this.formatDateForExport(new Date(end))}`;

    // === PAGE 1 : Header & résumé ===
    pdf.setFontSize(16);
    pdf.text(`Jalons - ${projectName}`, margin, 16);

    pdf.setFontSize(10);
    pdf.text(`Projet : ${projectName}`, margin, 24);
    pdf.text(`Caméra : ${cameraName}`, margin, 29);
    pdf.text(`Période : ${periodLabel}`, margin, 34);
    pdf.text(`Export : ${exportLabel}`, margin, 39);

    const totalPhases = this.localPhases.length;
    const grouped = this.buildPhasesGroupedByLane();
    const totalLanes = grouped.length;

    pdf.text(`Nombre de jalons : ${totalPhases}`, margin, 46);
    pdf.text(`Nombre de lots : ${totalLanes}`, margin, 51);

    let currentY = 60;

    // === TABLEAUX PAR LOT / VOIE ===
    for (const group of grouped) {
      const laneTitle = group.lane;

      // Si on manque de place pour le titre + un début de tableau → nouvelle page
      if (currentY > pageHeight - 40) {
        pdf.addPage();
        currentY = 20;
      }

      pdf.setFontSize(12);
      pdf.text(`Lot / Voie : ${laneTitle}`, margin, currentY);
      currentY += 4;

      // Datas du tableau
      const body = group.phases.map((p: any) => {
        const start = p.start || p.date;
        const end = p.end || p.start || p.date;
        const dur = this.computeDurationDays(start, end);

        return [
          p.name || '',
          this.formatDateForExport(start),
          this.formatDateForExport(end),
          String(dur),
          p.color || '',
        ];
      });

      // @ts-ignore autotable typing
      autoTable(pdf, {
        startY: currentY + 2,
        head: [['Jalon', 'Début', 'Fin', 'Durée (j)', 'Couleur']],
        body,
        styles: {
          fontSize: 8,
          cellPadding: 2,
        },
        headStyles: {
          fillColor: [0, 40, 80],
          textColor: 255,
        },
        alternateRowStyles: {
          fillColor: [240, 240, 240],
        },
        margin: { left: margin, right: margin },
        didDrawPage: () => {
          // ✅ méthode officielle jsPDF, bien typée
          const page = pdf.getNumberOfPages();
          pdf.setFontSize(8);
          pdf.text(`Page ${page}`, pageWidth - margin - 20, pageHeight - 5);
        },
      });

      // Récupérer la position Y après ce tableau
      // @ts-ignore
      currentY = (pdf as any).lastAutoTable.finalY + 8;
    }

    // === PAGE FINALE : capture du Gantt ===
    const ganttEl = this.$refs.phaseGantt as HTMLElement | undefined;

    if (ganttEl) {
      pdf.addPage();

      // petit titre pour la page Gantt
      pdf.setFontSize(14);
      pdf.text('Diagramme de Gantt des jalons', margin, 16);

      try {
        // On force le scroll tout en haut pour capturer le début
        ganttEl.scrollTop = 0;

        const canvas = await html2canvas(ganttEl, {
          scale: 2,
          useCORS: true,
          backgroundColor: '#001326',
        });

        const imgData = canvas.toDataURL('image/png');

        const availWidth = pageWidth - margin * 2;
        const imgHeight = (canvas.height * availWidth) / canvas.width;

        const posY = 22;
        if (imgHeight > pageHeight - posY - margin) {
          // Si trop haut, on scale pour tenir dans la page
          const maxHeight = pageHeight - posY - margin;
          const scale = maxHeight / imgHeight;
          const scaledWidth = availWidth * scale;
          const offsetX = margin + (availWidth - scaledWidth) / 2;

          pdf.addImage(imgData, 'PNG', offsetX, posY, scaledWidth, maxHeight);
        } else {
          pdf.addImage(imgData, 'PNG', margin, posY, availWidth, imgHeight);
        }
      } catch (error) {
        console.error('Erreur capture Gantt pour PDF :', error);
        this.$bvToast.toast('Erreur lors de la capture du Gantt dans le PDF', {
          title: this.$t('global.error')?.toString() || 'Erreur',
          variant: 'warning',
          solid: true,
        });
      }
    }

    // === Sauvegarde du fichier ===
    const safeProject = projectName.replace(/[^\w]+/g, '-');
    const fileName = `jalons-${safeProject}-${exportDate.toISOString().slice(0, 10)}.pdf`;

    pdf.save(fileName);
  }

  public onAddPhaseClick(): void {
    if (!this.currentImageKey) {
      this.$bvToast.toast(this.$t('gallery.nophoto').toString(), {
        title: this.$t('global.info').toString(),
        variant: 'info',
        solid: true,
      });
      return;
    }

    const photoDate = new Date(this.currentImageKey.createdAt);

    const defaultName =
      this.$options.filters && (this.$options.filters as any).dateFormat
        ? `Phase du ${(this.$options.filters as any).dateFormat(photoDate, this.dateFormat)}`
        : `Phase du ${photoDate.toLocaleDateString()}`;

    this.phaseModalMode = 'create';
    this.phaseModalPhoto = this.currentImageKey;
    this.phaseModalPhaseId = null;
    this.phaseModalLabel = defaultName;

    this.phaseModalColor = '#5fc9e4';

    // 🆕 par défaut : début/fin = date de la photo
    this.phaseModalStart = photoDate;
    this.phaseModalEnd = photoDate;
    this.phaseModalLane = '';
    this.phaseModalLaneSelect = null;

    this.phaseLinkStartId = null;
    this.phaseLinkEndId = null;

    this.phaseStartLinkKey = null;
    this.phaseEndLinkKey = null;

    (this.$refs.phaseModal as any).show();
  }

  public onPhaseContextMenu(photo: Photo): void {
    if (!photo) return;

    const mark = this.phaseMarksByPhotoId[photo.id];
    if (!mark) return;

    this.phaseModalMode = 'edit';
    this.phaseModalPhoto = photo;
    this.phaseModalPhaseId = mark.phaseId || null;
    this.phaseModalLabel = mark.label;
    this.phaseModalColor = mark.color || '#5fc9e4';

    this.phaseLinkStartId = null;
    this.phaseLinkEndId = null;
    this.phaseStartLinkKey = null;
    this.phaseEndLinkKey = null;

    const existingPhase = this.localPhases.find((p) => p.id === mark.phaseId);
    if (existingPhase) {
      const baseDate = new Date(existingPhase.date as any);
      this.phaseModalStart = existingPhase.start ? new Date(existingPhase.start as any) : baseDate;
      this.phaseModalEnd = existingPhase.end ? new Date(existingPhase.end as any) : baseDate;
      this.phaseModalLane = (existingPhase as any).lane || '';
    } else {
      const photoDate = new Date(photo.createdAt);
      this.phaseModalStart = photoDate;
      this.phaseModalEnd = photoDate;
      this.phaseModalLane = '';
    }

    (this.$refs.phaseModal as any).show();
  }

  public onPhaseModalCancel(): void {
    (this.$refs.phaseModal as any).hide();
  }

  public get phaseColorSuggestions(): string[] {
    const colors: string[] = [];
    const seen = new Set<string>();

    // 1) Couleurs venant des phases (copie locale)
    if (this.localPhases && this.localPhases.length > 0) {
      for (const phase of this.localPhases) {
        if (phase.color && !seen.has(phase.color)) {
          seen.add(phase.color);
          colors.push(phase.color);
        }
      }
    }

    // 2) Couleurs déjà utilisées localement sur les marks (phaseMarksByPhotoId)
    for (const id in this.phaseMarksByPhotoId) {
      if (!Object.prototype.hasOwnProperty.call(this.phaseMarksByPhotoId, id)) continue;

      const mark = this.phaseMarksByPhotoId[id];
      if (mark && mark.color && !seen.has(mark.color)) {
        seen.add(mark.color);
        colors.push(mark.color);
      }
    }

    // 3) Couleur actuellement sélectionnée dans la modal → en premier
    if (this.phaseModalColor) {
      const current = this.phaseModalColor;

      if (!seen.has(current)) {
        return [current, ...colors];
      }

      return [current, ...colors.filter((c) => c !== current)];
    }

    return colors;
  }

  public onPhaseModalConfirm(): void {
    const label = this.phaseModalLabel.trim();
    const photo = this.phaseModalPhoto;

    if (!photo || !label) {
      return;
    }

    // Normalisation des dates pour la copie locale (Gantt)
    const startIso = this.phaseModalStart ? this.phaseModalStart.toISOString() : photo.createdAt;
    const endIso = this.phaseModalEnd ? this.phaseModalEnd.toISOString() : startIso;
    const lane = this.phaseModalLane.trim() || undefined;

    if (this.phaseModalMode === 'create') {
      // Id temporaire pour la ligne locale du Gantt
      const localId = `local-${Date.now()}-${Math.random().toString(36).substr(2, 5)}`;

      // Mark sur le slider
      this.phaseMarksByPhotoId = {
        ...this.phaseMarksByPhotoId,
        [photo.id]: {
          label,
          color: this.phaseModalColor,
          phaseId: localId,
        },
      };

      // MAJ immédiate du Gantt (copie locale)
      this.localPhases = [
        ...this.localPhases,
        {
          id: localId,
          name: label,
          date: photo.createdAt,
          color: this.phaseModalColor,
          start: startIso,
          end: endIso,
          lane,
        },
      ];
      this.selectedPhaseTaskId = localId;

      // Payload pour le parent (API / store)
      const payload: any = {
        name: label,
        date: photo.createdAt,
        color: this.phaseModalColor,
      };

      if (this.phaseModalStart) {
        payload.start = startIso;
      }
      if (this.phaseModalEnd) {
        payload.end = endIso;
      }
      if (lane) {
        payload.lane = lane;
      }

      this.$emit('create-phase', payload);

      this.$bvToast.toast(this.$t('gallery.phaseCreated').toString(), {
        title: this.$t('global.success').toString(),
        variant: 'success',
        solid: true,
      });
    } else {
      const prev = this.phaseMarksByPhotoId[photo.id];

      this.phaseMarksByPhotoId = {
        ...this.phaseMarksByPhotoId,
        [photo.id]: {
          ...prev,
          label,
          color: this.phaseModalColor,
        },
      };

      if (this.phaseModalPhaseId) {
        // MAJ immédiate du Gantt sur la copie locale
        this.localPhases = this.localPhases.map((p) =>
          p.id === this.phaseModalPhaseId
            ? {
                ...p,
                name: label,
                color: this.phaseModalColor,
                // 🔥 on synchronise aussi la "date" de référence
                date: startIso,
                start: startIso,
                end: endIso,
                lane,
              }
            : p
        );
        this.selectedPhaseTaskId = this.phaseModalPhaseId;

        const payload: any = {
          id: this.phaseModalPhaseId,
          name: label,
          color: this.phaseModalColor,
          // 🔥 on envoie la nouvelle date au parent
          date: startIso,
        };

        if (this.phaseModalStart) {
          payload.start = startIso;
        }
        if (this.phaseModalEnd) {
          payload.end = endIso;
        }
        if (lane) {
          payload.lane = lane;
        }

        this.$emit('update-phase', payload);
      }

      // (optionnel, mais utile si tu veux recalculer les pastilles en fonction de la nouvelle date)
      this.recomputePhaseMarks();
    }

    // ❌ On ne ferme plus la modale ici
    // (this.$refs.phaseModal as any).hide();
  }

  public getPhaseColor(photo: Photo): string {
    if (!photo) return '#5fc9e4';
    const mark = this.phaseMarksByPhotoId[photo.id];
    return mark?.color || '#5fc9e4'; // couleur par défaut
  }

  public onPhaseModalDelete(): void {
    const photo = this.phaseModalPhoto;
    const phaseId = this.phaseModalPhaseId;

    if (!photo) return;

    const copy = { ...this.phaseMarksByPhotoId };
    delete copy[photo.id];
    this.phaseMarksByPhotoId = copy;

    if (phaseId) {
      // MAJ immédiate du Gantt local
      this.localPhases = this.localPhases.filter((p) => p.id !== phaseId);
      this.selectedPhaseTaskId = null;

      this.$emit('delete-phase', { id: phaseId });
    }

    this.$bvToast.toast(this.$t('gallery.phaseDeleted').toString(), {
      title: this.$t('global.success').toString(),
      variant: 'success',
      solid: true,
    });

    (this.$refs.phaseModal as any).hide();
  }

  public onPhaseClick(photo: Photo): void {
    if (!photo) return;

    this.currentImageKey = photo;
    this.sliderValue = photo;

    const index = this.imagesKey.findIndex((p) => p.id === photo.id);
    if (index !== -1 && this.slider) {
      this.slider.setIndex(index);
    }

    const photoDate = new Date(photo.createdAt);
    this.$emit('photoChanged', photoDate);
  }

  private findClosestPhotoToDate(date: Date): Photo | null {
    if (this.imagesKey.length === 0) return null;

    let closest: Photo = this.imagesKey[0];
    let closestDiff = Math.abs(new Date(closest.createdAt).getTime() - date.getTime());

    for (const photo of this.imagesKey) {
      const diff = Math.abs(new Date(photo.createdAt).getTime() - date.getTime());
      if (diff < closestDiff) {
        closestDiff = diff;
        closest = photo;
      }
    }

    return closest;
  }

  public async onCopyImage(): Promise<void> {
    if (this.currentImageKey) {
      try {
        const sourceKey = this.currentImageKey.key; // Chemin de l'image actuelle
        const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
        const fileExtension = sourceKey.split('.').pop()?.split('?')[0] || 'jpg';
        // Génération d'un nom de fichier pour l'image uploadée sur Roboflow
        const fileName = `copied-${timestamp}.${fileExtension}`;

        // Télécharger l'image depuis S3
        const response = (await Storage.get(sourceKey, { download: true })) as S3GetResponse;
        const body = response.Body;

        // Vérifier si Body est un Blob ou un ArrayBuffer
        if (body instanceof Blob || body instanceof ArrayBuffer) {
          const imageBlob = body instanceof Blob ? body : new Blob([body], { type: `image/${fileExtension}` });

          // Créer un FormData pour l'envoi vers Roboflow
          const formData = new FormData();
          formData.append('name', fileName);
          formData.append('file', imageBlob, fileName);
          formData.append('split', 'train'); // Modifier si nécessaire (ex: "valid", "test", ...)

          // Configuration Roboflow (remplacez par vos valeurs)
          const ROBOFLOW_API_KEY = 'sMvFYAUEXICXjfJaPDAs';
          const ROBOFLOW_DATASET = this.useIA ? 'erige' : this.useSecurityMode ? 'excavation-2' : 'excavation-2';

          // Envoi de la requête POST à Roboflow
          const axiosResponse = await axios.post(
            `https://api.roboflow.com/dataset/${ROBOFLOW_DATASET}/upload`,
            formData,
            {
              params: {
                api_key: ROBOFLOW_API_KEY,
              },
              // En environnement navigateur, axios gère automatiquement l'en-tête multipart/form-data
            }
          );

          console.log('Réponse Roboflow :', axiosResponse.data);
          this.$bvToast.toast(this.$t('gallery.copySuccess').toString(), {
            title: 'Succès',
            variant: 'success',
            solid: true,
          });
        } else {
          throw new Error("Le fichier téléchargé n'est pas un Blob ou un ArrayBuffer.");
        }
      } catch (error) {
        // On récupère la chaîne de l'erreur pour voir si elle contient "Network Error"
        const errorStr = error && error.toString ? error.toString() : '';
        if (errorStr.includes('Network Error')) {
          console.log("Network Error détecté, mais l'upload semble réussi d'après les logs réseau.");
          this.$bvToast.toast(this.$t('gallery.copySuccess').toString(), {
            title: 'Succès',
            variant: 'success',
            solid: true,
          });
          try {
            await axios.post('https://ncv8s6bnc5.execute-api.eu-west-3.amazonaws.com/prod/send-email', {});
            console.log('Email de notification envoyé via Lambda.');
          } catch (emailError) {
            console.error("Erreur lors de l'envoi de l'email :", emailError);
          }
        } else {
          console.error("Erreur lors de l'upload de l'image vers Roboflow :", error);
          this.$bvToast.toast(this.$t('gallery.copyError').toString(), {
            title: 'Erreur',
            variant: 'danger',
            solid: true,
          });
        }
      }
    } else {
      console.warn("Aucune image sélectionnée pour l'upload.");
    }
  }

  private getGanttRange(): { start: number; end: number } {
    let start = Infinity;
    let end = -Infinity;

    // 1) Photos (timeline globale du chantier)
    if (this.imagesKey.length > 0) {
      const firstPhoto = new Date(this.imagesKey[0].createdAt).getTime();
      const lastPhoto = new Date(this.imagesKey[this.imagesKey.length - 1].createdAt).getTime();
      start = Math.min(start, firstPhoto);
      end = Math.max(end, lastPhoto);
    }

    // 2) Phases (avec start/end si dispo) → copie locale
    if (this.localPhases && this.localPhases.length > 0) {
      for (const phaseAny of this.localPhases as any[]) {
        const phase = phaseAny as {
          date: string | Date;
          start?: string | Date;
          end?: string | Date;
        };

        const tStart = new Date(phase.start || phase.date).getTime();
        const tEnd = phase.end ? new Date(phase.end).getTime() : tStart;

        start = Math.min(start, tStart);
        end = Math.max(end, tEnd);
      }
    }

    if (!isFinite(start) || !isFinite(end) || start === end) {
      const now = Date.now();
      return { start: now - 1, end: now };
    }

    return { start, end };
  }

  public get ganttTasks(): GanttTask[] {
    if (!this.localPhases || this.localPhases.length === 0) {
      return [];
    }

    const { start: rangeStart, end: rangeEnd } = this.getGanttRange();
    const total = Math.max(rangeEnd - rangeStart, 1);

    const rawTasks: GanttTask[] = (this.localPhases as any[]).map((phaseAny) => {
      const phase = phaseAny as {
        id: string;
        name: string;
        date: string | Date;
        color?: string;
        start?: string | Date;
        end?: string | Date;
        lane?: string;
      };

      const startDate = new Date(phase.start || phase.date);
      let endDate: Date;

      if (phase.end) {
        endDate = new Date(phase.end);
      } else {
        endDate = new Date(startDate.getTime() + 24 * 60 * 60 * 1000);
      }

      let startTs = startDate.getTime();
      let endTs = endDate.getTime();

      if (!isFinite(startTs) || !isFinite(endTs)) {
        startTs = rangeStart;
        endTs = rangeStart + 24 * 60 * 60 * 1000;
      }

      if (endTs <= startTs) {
        endTs = startTs + 24 * 60 * 60 * 1000;
      }

      startTs = Math.max(startTs, rangeStart);
      endTs = Math.min(endTs, rangeEnd);

      const left = ((startTs - rangeStart) / total) * 100;
      const width = ((endTs - startTs) / total) * 100;

      return {
        id: phase.id,
        name: phase.name,
        color: phase.color || '#5fc9e4',
        left,
        width,
        startDate: new Date(startTs),
        endDate: new Date(endTs),
        lane: phase.lane,
        type: 'phase',
      };
    });

    return rawTasks.sort((a, b) => {
      const laneA = a.lane || '';
      const laneB = b.lane || '';
      if (laneA !== laneB) {
        return laneA.localeCompare(laneB);
      }
      return a.startDate.getTime() - b.startDate.getTime();
    });
  }

  public get ganttTasksWithProject(): GanttTask[] {
    const phases = this.ganttTasks || [];
    if (!phases.length) return [];

    const { start, end } = this.getGanttRange();
    const total = Math.max(end - start, 1);

    const projectTask: GanttTask = {
      id: 'project',
      name: this.project?.name || 'Projet',
      startDate: new Date(start),
      endDate: new Date(end),
      left: 0,
      width: 100,
      color: '#ffffff',
      lane: 'Projet',
      type: 'project',
    };

    // Regroupement par lot (lane)
    const byLane: { [lane: string]: GanttTask[] } = {};
    const defaultLaneLabel = 'Sans lot';

    for (const task of phases) {
      const laneName = task.lane && task.lane.trim().length > 0 ? task.lane : defaultLaneLabel;
      if (!byLane[laneName]) {
        byLane[laneName] = [];
      }
      byLane[laneName].push(task);
    }

    const rows: GanttTask[] = [projectTask];

    Object.keys(byLane)
      .sort((a, b) => a.localeCompare(b, 'fr', { sensitivity: 'base' }))
      .forEach((laneName) => {
        const laneTasks = byLane[laneName];
        let laneStart = laneTasks[0].startDate.getTime();
        let laneEnd = laneTasks[0].endDate.getTime();

        for (const t of laneTasks) {
          laneStart = Math.min(laneStart, t.startDate.getTime());
          laneEnd = Math.max(laneEnd, t.endDate.getTime());
        }

        // bornage par la plage globale Gantt (tous jalons confondus)
        laneStart = Math.max(laneStart, start);
        laneEnd = Math.min(laneEnd, end);

        const left = ((laneStart - start) / total) * 100;
        const width = ((laneEnd - laneStart) / total) * 100;

        const laneColor = laneTasks[0].color || '#5fc9e4';
        const isCollapsed = this.collapsedLanes.includes(laneName);

        const laneTask: GanttTask = {
          id: `lane:${laneName}`,
          name: laneName,
          lane: laneName,
          color: laneColor,
          startDate: new Date(laneStart),
          endDate: new Date(laneEnd),
          left,
          width,
          type: 'lane',
          isCollapsed,
        };

        rows.push(laneTask);

        // Si le lot est déplié → on ajoute ses jalons dessous
        if (!isCollapsed) {
          rows.push(...laneTasks);
        }
      });

    return rows;
  }

  public get ganttStartLabel(): string {
    const { start } = this.getGanttRange();
    const d = new Date(start);

    if (this.$options.filters && (this.$options.filters as any).dateFormat) {
      return (this.$options.filters as any).dateFormat(d, this.dateFormat);
    }

    return d.toLocaleDateString();
  }

  public get ganttEndLabel(): string {
    const { end } = this.getGanttRange();
    const d = new Date(end);

    if (this.$options.filters && (this.$options.filters as any).dateFormat) {
      return (this.$options.filters as any).dateFormat(d, this.dateFormat);
    }

    return d.toLocaleDateString();
  }

  public ganttBarTooltip(task: GanttTask): string {
    const hasFilter = this.$options.filters && (this.$options.filters as any).dateFormat;

    const startLabel = hasFilter
      ? (this.$options.filters as any).dateFormat(task.startDate, this.dateFormat)
      : task.startDate.toLocaleDateString();
    const endLabel = hasFilter
      ? (this.$options.filters as any).dateFormat(task.endDate, this.dateFormat)
      : task.endDate.toLocaleDateString();

    return `${task.name} : ${startLabel} → ${endLabel}`;
  }

  public onGanttBarClick(task: GanttTask): void {
    if (task.type === 'project') {
      const midTs = (task.startDate.getTime() + task.endDate.getTime()) / 2;
      const midDate = new Date(midTs);
      this.goToClosestPhoto(midDate);
      return;
    }

    if (task.type === 'lane' && task.lane) {
      this.onToggleLane(task.lane);
      return;
    }

    // jalon normal
    this.selectPhaseFromTask(task);
  }

  public onGanttRowClick(task: GanttTask): void {
    if (task.type === 'lane' && task.lane) {
      this.onToggleLane(task.lane);
      return;
    }

    if (task.type === 'project') {
      this.onGanttBarClick(task);
      return;
    }

    this.selectPhaseFromTask(task);
  }

  public onDoubleClickZoom(): void {
    if (this.zoomLevel < 3) {
      this.zoomLevel = 3;
    } else {
      this.zoomLevel = 1;
    }
  }

  public onTouchStart(event: TouchEvent): void {
    if (event.touches.length !== 1) return;

    if (!this.canSwipe) {
      event.preventDefault();
      return;
    }

    this.touchStartX = event.touches[0].clientX;
    this.touchStartY = event.touches[0].clientY;
    this.touchStartTime = Date.now(); // Nouveau : enregistre le timestamp
    this.isSwiping = false;
  }

  public onTouchMove(event: TouchEvent): void {
    if (event.touches.length !== 1) return;

    if (!this.canSwipe) {
      event.preventDefault();
      return;
    }

    if (!this.isSwiping) {
      const currentX = event.touches[0].clientX;
      const currentY = event.touches[0].clientY;

      const deltaX = Math.abs(currentX - this.touchStartX);
      const deltaY = Math.abs(currentY - this.touchStartY);

      if (deltaX > this.minSwipeDistance && deltaY < this.maxVerticalDistance) {
        this.isSwiping = true;
        this.touchEndX = currentX;
        this.touchEndY = currentY;

        event.preventDefault();
        event.stopPropagation();

        this.handleSwipe();
      }
    }
  }

  public onTouchEnd(_: TouchEvent): void {
    if (!this.canSwipe) return;

    if (this.isSwiping) {
      this.isSwiping = false;
      this.touchStartX = 0;
      this.touchStartY = 0;
      this.touchEndX = 0;
      this.touchEndY = 0;
      this.touchStartTime = 0; // Reset
    }
  }

  private handleSwipe(): void {
    const swipeTime = Date.now() - this.touchStartTime; // Nouveau : calcule le temps écoulé
    if (swipeTime > this.minSwipeTime) {
      return; // Ignore si trop rapide
    }

    const swipeDistance = this.touchEndX - this.touchStartX;

    if (Math.abs(swipeDistance) >= this.minSwipeDistance) {
      if (swipeDistance > 0) {
        this.onPrevImageClick();
      } else {
        this.onNextImageClick();
      }
    }
  }

  mounted(): void {
    logger.info('mounted');
    document.addEventListener('keyup', this.onNextSlide);
    if (this.zoom) {
      document.addEventListener('keyup', this.onNextSlide);
    }

    if (!this.isLoadingPhoto) {
      this.$nextTick(() => {
        const zoomerElement = this.$el.querySelector('.gallery-photo-preview-container') as HTMLElement;
        if (zoomerElement) {
          zoomerElement.addEventListener('wheel', this.onWheelZoom);
        }
      });
    }

    // New: Attempt to add touch listeners if element is already available
    if (this.currentImageKey) {
      this.$nextTick(this.addTouchListeners);
    }

    const zone: HTMLElement | undefined =
      (this.$refs.zoomerMedium as any)?.$el ||
      (this.$el.querySelector('.gallery-photo-preview-container-image') as HTMLElement);

    if (!zone) return;

    // iOS: annule le pinch-to-zoom page (laisser v-zoomer gérer le pinch)
    this._cancelPinch = (e: TouchEvent) => {
      if (e.touches && e.touches.length > 1) {
        e.preventDefault();
      }
    };

    // iOS: évite le "double-tap zoom" page - modifié pour ne pas interférer avec le swipe
    this._cancelDoubleTap = (e: TouchEvent) => {
      const now = Date.now();
      if (now - this._lastTouchTs < 350 && !this.isSwiping) {
        e.preventDefault();
      }
      this._lastTouchTs = now;
    };

    zone.addEventListener('touchmove', this._cancelPinch, { passive: false });
    zone.addEventListener('touchstart', this._cancelDoubleTap, { passive: false });
    this.$root.$on('go-to-photo-from-audio', this.onGoToPhotoFromAudio);
  }

  beforeDestroy() {
    // New: Cleanup using ref
    const swipeZone = this.$refs.swipeZone as HTMLElement | undefined;
    if (swipeZone) {
      swipeZone.removeEventListener('touchstart', this.onTouchStart, true);
      swipeZone.removeEventListener('touchmove', this.onTouchMove, true);
      swipeZone.removeEventListener('touchend', this.onTouchEnd, true);
    }

    const zone: HTMLElement | undefined =
      (this.$refs.zoomerMedium as any)?.$el ||
      (this.$el.querySelector('.gallery-photo-preview-container-image') as HTMLElement);

    if (zone) {
      if (this._cancelPinch) zone.removeEventListener('touchmove', this._cancelPinch as any);
      if (this._cancelDoubleTap) zone.removeEventListener('touchstart', this._cancelDoubleTap as any);
    }

    const zoomerElement = this.$el.querySelector('.gallery-photo-preview-container') as HTMLElement | null;
    if (zoomerElement) zoomerElement.removeEventListener('wheel', this.onWheelZoom);
    document.removeEventListener('keyup', this.onNextSlide);
    this.$root.$off('go-to-photo-from-audio', this.onGoToPhotoFromAudio);
  }

  private filterImagesWithinLagDuration(images: Photo[], lagduration: number): Photo[] {
    const now = new Date();
    const cutoffTime = new Date(now.getTime() - lagduration * 60 * 60 * 1000); // lagduration hours ago
    return images.filter((image) => new Date(image.createdAt) < cutoffTime);
  }

  public focusPhotoById(photoId: string, date?: Date | string): void {
    if (!photoId) return;

    // 1) On essaye d'abord de retrouver la photo par son id
    const photo = this.imagesKey.find((p) => p.id === photoId);

    if (photo) {
      this.currentImageKey = photo;
      this.sliderValue = photo;

      const index = this.imagesKey.findIndex((p) => p.id === photo.id);
      if (index !== -1 && this.slider) {
        this.slider.setIndex(index);
      }

      const photoDate = new Date(photo.createdAt);
      this.$emit('photoChanged', photoDate);
      return;
    }

    // 2) Si on ne trouve pas l'id mais qu'on a une date -> on se rabat
    if (date) {
      const d = date instanceof Date ? date : new Date(date);
      this.goToClosestPhoto(d);
      this.$emit('photoChanged', d);
    }
  }

  private onGoToPhotoFromAudio(payload: { photoId: string; date: Date; cameraId: string; projectId: string }): void {
    if (!payload) return;

    // On vérifie qu'on est bien sur la bonne caméra / projet
    if (payload.cameraId !== this.camera.id || payload.projectId !== this.project.id) {
      return;
    }

    this.focusPhotoById(payload.photoId, payload.date);
  }

  public getRotation(): string {
    return this.camera && this.camera.rotate ? `rotate(${this.camera.rotate}deg)` : '';
  }

  public togglDirection(mode: 'r' | 'b' | 's'): void {
    this.$emit('switchmode', mode);
    if (this.$refs.galleryCompare) {
      (this.$refs.galleryCompare as any).resetImages();
    }
  }

  public takePicture(): void {
    cameraService.takePicture(this.camera.id);
  }

  private recomputePhaseMarks(): void {
    this.phaseMarksByPhotoId = {};

    if (!this.localPhases || this.localPhases.length === 0 || this.imagesKey.length === 0) {
      return;
    }

    for (const phase of this.localPhases as any[]) {
      // 👉 On prend start en priorité, sinon date
      const anchorRaw = phase.start || phase.date;
      if (!anchorRaw) continue;

      const phaseDate = new Date(anchorRaw as any);
      const closest = this.findClosestPhotoToDate(phaseDate);
      if (closest) {
        this.phaseMarksByPhotoId[closest.id] = {
          label: phase.name,
          phaseId: phase.id,
          color: phase.color,
        };
      }
    }
  }

  public async handleTakePicture(): Promise<void> {
    this.isTakingPicture = true; // Activer le loader
    try {
      await cameraService.takePicture(this.camera.id); // Appeler le service pour prendre une photo
      this.waitForPhotoNotification(); // Attendre la notification (ou une promesse)
    } catch (error) {
      console.error('Erreur lors de la prise de photo :', error);
      this.isTakingPicture = false; // Désactiver le loader en cas d'erreur
    }
  }

  public async handleMiroring(): Promise<void> {
    // Pour éviter que l'utilisateur ne reclique pendant la phase "spinner"
    //if (this.isMirroring) return;

    this.isMirroring = true; // Active le spinner

    try {
      // Appel à votre service (remplacez par votre logique réelle)
      await cameraService.Miroring(this.camera.id);

      // Une fois la requête effectuée, on laisse le spinner pendant 8 secondes
      setTimeout(() => {
        // On arrête le spinner
        this.isMirroring = false;
        // On affiche l'icône de validation
        this.mirroringSuccess = true;

        // Puis 2 secondes plus tard, on remet l'icône de base
        setTimeout(() => {
          this.mirroringSuccess = false;
        }, 2000);
      }, 5000);
    } catch (error) {
      console.error('Erreur lors du miroring :', error);
      // Si erreur, on désactive le spinner
      this.isMirroring = false;
      // On peut éventuellement afficher une notification d'erreur ici
    }
  }

  private waitForPhotoNotification(): void {
    const timeout = setTimeout(() => {
      clearInterval(checkPhotoInterval);
      this.isTakingPicture = false; // Désactiver le loader après un délai
    }, 30000); // Timeout après 15 secondes

    const checkPhotoInterval = setInterval(() => {
      if (this.newPhotoAvailable) {
        clearTimeout(timeout); // Annuler le timeout
        clearInterval(checkPhotoInterval); // Arrêter l'intervalle
        this.isTakingPicture = false; // Désactiver le loader
      }
    }, 500);
  }

  public refreshPhoto(): void {
    // eslint-disable-next-line vue/custom-event-name-casing
    this.$emit('refreshPhoto');
  }

  @Watch('newPhotoAvailable')
  onNewPhotoAvailableChanged(newVal: boolean): void {
    if (newVal) {
      setTimeout(() => {
        this.refreshPhoto();
      }, 2000);
    }
  }

  @Watch('pickedDate')
  public onDatePick(val: Date, oldVal: Date | null): void {
    logger.info('pickedDate', { val, oldVal });
    if (oldVal !== null) {
      let closestPhoto: Photo | null = null;
      let closestDistance = Infinity;

      for (const imageKey of this.imagesKey) {
        const photoDate = new Date(imageKey.createdAt);
        photoDate.setHours(photoDate.getHours() + photoDate.getTimezoneOffset() / 60);
        const localDistance = Math.abs(val.getTime() - photoDate.getTime());
        if (localDistance < closestDistance) {
          closestDistance = localDistance;
          closestPhoto = imageKey;
        }
      }

      if (closestPhoto) {
        this.currentImageKey = closestPhoto;
        this.sliderValue = this.currentImageKey;
        this.$emit('photoChanged', new Date(closestPhoto.createdAt)); // Émission de l'événement
      } else {
        alert('Aucune image trouvée.');
      }
    }
  }

  @Watch('imagesKey', { immediate: true, deep: true })
  onImagesKeyForMarksChange(): void {
    this.recomputePhaseMarks();
  }

  @Watch('phases', { immediate: true, deep: true })
  onPhasesChange(newVal: any[]): void {
    // copie locale pour le Gantt
    this.localPhases = (newVal || []).map((p) => ({ ...p }));
    this.recomputePhaseMarks();
  }

  @Watch('phaseLinkStartId')
  onPhaseLinkStartChange(id: string | null): void {
    if (!id) return;
    if (!this.localPhases || !this.localPhases.length) return;

    const ref = (this.localPhases as any[]).find((p) => p.id === id);
    if (!ref) return;

    // On prend start en priorité, sinon date
    const raw = ref.start || ref.date;
    if (!raw) return;

    this.phaseModalStart = new Date(raw as any);
  }

  @Watch('phaseStartLinkKey')
  onPhaseStartLinkKeyChange(val: string | null): void {
    if (!val) {
      // "Définir manuellement" → on garde la valeur actuelle
      return;
    }

    if (!this.localPhases || !this.localPhases.length) return;

    const [id, anchor] = val.split('|');
    if (!id || !anchor) return;

    const ref = (this.localPhases as any[]).find((p) => p.id === id);
    if (!ref) return;

    let raw: string | Date | undefined;

    if (anchor === 'start') {
      // début du jalon ref : start ou date
      raw = ref.start || ref.date;
    } else if (anchor === 'end') {
      // fin du jalon ref : end ou start ou date
      raw = ref.end || ref.start || ref.date;
    }

    if (!raw) return;

    this.phaseModalStart = new Date(raw as any);
  }

  @Watch('phaseEndLinkKey')
  onPhaseEndLinkKeyChange(val: string | null): void {
    if (!val) {
      // "Définir manuellement"
      return;
    }

    if (!this.localPhases || !this.localPhases.length) return;

    const [id, anchor] = val.split('|');
    if (!id || !anchor) return;

    const ref = (this.localPhases as any[]).find((p) => p.id === id);
    if (!ref) return;

    let raw: string | Date | undefined;

    if (anchor === 'start') {
      // Fin = début du jalon ref
      raw = ref.start || ref.date;
    } else if (anchor === 'end') {
      // Fin = fin du jalon ref
      raw = ref.end || ref.start || ref.date;
    }

    if (!raw) return;

    this.phaseModalEnd = new Date(raw as any);
  }

  // Quand on choisit un jalon pour définir la fin
  @Watch('phaseLinkEndId')
  onPhaseLinkEndChange(id: string | null): void {
    if (!id) return;
    if (!this.localPhases || !this.localPhases.length) return;

    const ref = (this.localPhases as any[]).find((p) => p.id === id);
    if (!ref) return;

    // Pour la fin on prend end si dispo, sinon start, sinon date
    const raw = ref.end || ref.start || ref.date;
    if (!raw) return;

    this.phaseModalEnd = new Date(raw as any);
  }

  @Watch('phaseModalLaneSelect')
  onPhaseModalLaneSelectChange(val: string | null): void {
    if (val && val !== '__custom__') {
      // lot existant choisi → on le met dans la valeur envoyée
      this.phaseModalLane = val;
    } else if (val === '__custom__') {
      // mode saisie libre → on laisse l'utilisateur taper
      if (!this.phaseModalLane) {
        this.phaseModalLane = '';
      }
    }
  }

  @Watch('imagesKey')
  onImagesKeyChange(newVal: Photo[]) {
    this.currentImageKey = newVal.length > 0 ? newVal[newVal.length - 1] : null;
    this.sliderValue = this.currentImageKey;

    // Mettre à jour le pickedDate si nécessaire
    if (this.currentImageKey && this.pickedDate === null) {
      this.pickedDate = new Date(this.currentImageKey.createdAt);
      this.pickedDate.setHours(this.pickedDate.getHours() + this.pickedDate.getTimezoneOffset() / 60);
      this.pickedDate.setHours(12);
      this.pickedDate.setMinutes(0);
      this.pickedDate.setSeconds(0);
    }

    // Gérer le zoom initial pour les Tikee
    if (this.camera.isTikee === true && this.currentImageKey !== null) {
      const zoomLevel = this.camera.optic !== '4260x1534' ? 1 : 1.56;
      this.$nextTick(() => {
        // @ts-ignore no typescript def for $refs
        this.$refs.zoomerMedium?.reset();
        // @ts-ignore no typescript def for $refs
        this.$refs.zoomerMedium?.zoomIn(zoomLevel);
      });
    }

    // Recalage du slider à la dernière photo
    this.$nextTick(() => {
      if (this.slider && newVal.length > 0) {
        this.slider.setIndex(newVal.length - 1);
      }
    });
  }

  @Watch('selectedPhotos', { immediate: true, deep: true })
  public onSelectedPhotosChange(newVal: Photo[]): void {
    if (newVal && newVal.length > 0) {
      const selectedPhoto = newVal[0]; // Supposons une sélection unique
      this.currentImageKey = selectedPhoto;

      // Trouver l'index de la photo sélectionnée dans imagesKey
      const index = this.imagesKey.findIndex((photo) => photo.id === selectedPhoto.id);

      if (index !== -1 && this.slider) {
        this.slider.setIndex(index);
        this.sliderValue = selectedPhoto;
      }
    } else {
      // Si aucune photo n'est sélectionnée, réinitialiser à la dernière photo
      this.currentImageKey = this.imagesKey.length > 0 ? this.imagesKey[this.imagesKey.length - 1] : null;
      this.sliderValue = this.currentImageKey;
    }
  }

  public get sliderData(): string[] {
    return this.imagesKey.map((imageKey) => imageKey.smallKey);
  }

  public onSliderChange(value: Photo): void {
    if (!this.sliderIsDragging) {
      this.currentImageKey = value;
      const photoDate = new Date(value.createdAt);
      console.log('Emitting photoChanged with date:', photoDate);
      this.$emit('photoChanged', photoDate);
    }
    this.isSliderFirstItem = this.slider.getIndex() === 0;
    this.isSliderLastItem = this.slider.getIndex() === this.imagesKey.length - 1;
  }

  public goToClosestPhoto(date: Date): void {
    console.log('goToClosestPhoto called with date:', date);
    if (this.imagesKey.length === 0) return;
    let closestPhoto: Photo = this.imagesKey[0];
    let closestDiff = Math.abs(new Date(closestPhoto.createdAt).getTime() - date.getTime());

    for (const photo of this.imagesKey) {
      const diff = Math.abs(new Date(photo.createdAt).getTime() - date.getTime());
      if (diff < closestDiff) {
        closestDiff = diff;
        closestPhoto = photo;
      }
    }

    console.log('Found closest photo:', closestPhoto);
    this.currentImageKey = closestPhoto;
    const index = this.imagesKey.findIndex((p) => p.id === closestPhoto.id);
    if (index !== -1 && this.slider) {
      this.slider.setIndex(index);
      this.sliderValue = closestPhoto;
    } else {
      console.warn('Slider or photo index not found');
    }
  }

  public onSliderDragStart(): void {
    this.sliderIsDragging = true;
  }

  public onSliderDragEnd(): void {
    this.sliderIsDragging = false;
    this.currentImageKey = this.sliderValue;

    if (this.sliderValue) {
      const date = new Date(this.sliderValue.createdAt);
      this.goToClosestPhoto(date);
      this.$emit('photoChanged', date); // Émission de l'événement
    }
  }

  public onNextSlide(event: KeyboardEvent): void {
    if (event.keyCode === 37) {
      this.onPrevImageClick();
    } else if (event.keyCode === 39) {
      this.onNextImageClick();
    } else if (event.keyCode === 27 && this.zoom) {
      this.zoom = false;
    }
  }

  public onPrevImageClick(): void {
    if (this.slider) {
      const index = this.slider.getIndex() as number;
      if (index >= 1) {
        this.slider.setIndex(index - 1);
      } else {
        this.slider.setIndex(0);
      }
    }
  }

  public onNextImageClick(): void {
    if (this.slider) {
      const index = this.slider.getIndex() as number;
      if (index < this.imagesKey.length - 1) {
        this.slider.setIndex(index + 1);
      } else {
        this.slider.setIndex(this.imagesKey.length - 1);
      }
    }
  }

  public onshow(): void {
    logger.info('onShow');
    this.showCreateAlbum();
    this.showSelectAlbum();
    // eslint-disable-next-line vue/custom-event-name-casing
    this.$root.$emit('bv::show::popover', 'popover-favorite');
  }

  public onClose(): void {
    this.showCreateAlbum();
    this.showSelectAlbum();
    // eslint-disable-next-line vue/custom-event-name-casing
    this.$root.$emit('bv::hide::popover', 'popover-favorite');
  }

  public onDownload(): void {
    if (this.currentImageKey !== null) {
      const imageKey = this.currentImageKey;
      Storage.get(imageKey.key, { download: true })
        .then((response) => {
          saveAs(
            // @ts-ignore amplify no doc
            new Blob([response.Body], { type: 'image/jpeg' }),
            `${format(new Date(imageKey.createdAt), 'yyyyMMdd-HHmmss')}.jpg`
          );
        })
        .catch((error) => {
          console.error("Erreur lors du téléchargement de l'image:", error);
        });
    } else {
      console.warn('Aucune image sélectionnée pour le téléchargement.');
    }
  }

  public showCreateAlbum(): void {
    logger.info('showCreateAlbum');
    this.$v.selectedAlbum.$reset();
    this.selectedAlbum = '';
    this.photoFavAlbum = !this.photoFavAlbum;
  }

  public showSelectAlbum(): void {
    logger.info('showSelectAlbum');
    this.$v.createdAlbum.$reset();
    this.createdAlbum = '';
    this.photoFavAlbum = !this.photoFavAlbum;
  }

  private async onSelectAlbum(albumId: string) {
    logger.info('onSelectAlbum ' + albumId);
    this.$v.selectedAlbum.$touch();
    if (!this.$v.selectedAlbum.$invalid && this.currentImageKey !== null) {
      await this.addPhoto({ albumId, photoId: this.currentImageKey.id });
      this.onClose();
    }
  }

  private async onCreateAlbum(albumName: string) {
    logger.info('onCreateAlbum ' + albumName);
    this.$v.createdAlbum.$touch();
    if (!this.$v.createdAlbum.$invalid && this.currentImageKey !== null) {
      this.createNewAlbum({
        cameraId: this.camera.id,
        projectId: this.project.id,
        name: albumName,
        photoId: this.currentImageKey.id,
      });
      this.onClose();
    }
  }
}
